var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.service)?_c('v-row',[(_vm.service == 'regcivil_service')?_c('ag-regcivil-info'):_c('v-col',{attrs:{"cols":"12"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }